<div
  class="eventq-split-menu-button"
  [class.eventq-split-menu-button--disabled]="disabled()"
  [class.eventq-split-menu-button--open]="menuOpen()"
>
  <button
    type="button"
    class="eventq-split-menu-button__trigger"
    [attr.data-testid]="triggerTestId()"
    [disabled]="disabled()"
    [attr.aria-expanded]="menuOpen()"
    aria-haspopup="menu"
    (click)="toggleMenu()"
  >
    @if (iconSrc()) {
      <span
        class="eventq-split-menu-button__icon eventq-split-menu-button__glyph"
        [style.--eventq-split-menu-glyph]="iconStyle(iconSrc()!)"
        [attr.data-icon-src]="iconSrc()"
        aria-hidden="true"
      ></span>
    }
    <span class="eventq-split-menu-button__label">{{ label() }}</span>
    <span
      class="eventq-split-menu-button__chevron"
      [class.eventq-split-menu-button__chevron--open]="menuOpen()"
      data-testid="split-menu-chevron"
      aria-hidden="true"
    >
      @if (chevronSrc()) {
        <span
          class="eventq-split-menu-button__chevron-icon eventq-split-menu-button__glyph"
          [style.--eventq-split-menu-glyph]="iconStyle(chevronSrc()!)"
          [attr.data-icon-src]="chevronSrc()"
        ></span>
      } @else {
        ▲
      }
    </span>
  </button>

  <ul
    class="eventq-split-menu-button__menu"
    role="menu"
    [class.eventq-split-menu-button__menu--open]="menuOpen() && !disabled()"
    [attr.aria-hidden]="!(menuOpen() && !disabled())"
  >
    @for (option of options(); track option.id) {
      <li role="none">
        <button
          type="button"
          class="eventq-split-menu-button__option"
          [class.eventq-split-menu-button__option--disabled]="!!option.disabled"
          role="menuitem"
          [attr.data-option-id]="option.id"
          [disabled]="!!option.disabled"
          [attr.aria-disabled]="option.disabled ? true : null"
          (click)="selectOption(option.id)"
        >
          @if (option.iconSrc) {
            <span
              class="eventq-split-menu-button__option-icon eventq-split-menu-button__glyph"
              [style.--eventq-split-menu-glyph]="iconStyle(option.iconSrc)"
              [attr.data-icon-src]="option.iconSrc"
              aria-hidden="true"
            ></span>
          }
          <span>{{ option.label }}</span>
        </button>
      </li>
    }
  </ul>
</div>
